import { render, staticRenderFns } from "./ExCloneOrgObject.vue?vue&type=template&id=33faf6cb"
import script from "./ExCloneOrgObject.vue?vue&type=script&lang=js"
export * from "./ExCloneOrgObject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports